import {JSX, useEffect, useState} from "react";
import Board from "./Board";
import {AxiosResponse} from "axios";
import {
    getTwitchRequest,
    TwitchAuthDto,
    TwitchBroadcasterDtoOuter, TwitchContextDto
} from "../service/TwitchService";
import { useLocation } from "react-router-dom";

declare global {
    interface Window {
        Twitch: any;
    }
}

export default function BoardLoader(): JSX.Element {
    const [twitchName, twitchNameSet] = useState<string|null>();
    const [disabled, disabledSet] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const streamerName = queryParams.get('streamer');

        // for embedding on normal website
        if(streamerName) {
            twitchNameSet(streamerName);
        }
        // for twitch extension
        else if (window.Twitch && window.Twitch.ext) {
            window.Twitch.ext.onAuthorized = ((auth: TwitchAuthDto) => {
                console.log(auth);

                getTwitchRequest(auth).then((response: AxiosResponse<TwitchBroadcasterDtoOuter>) => {
                    console.log(response);

                    twitchNameSet(response.data.data[0].broadcaster_name);
                }, () => {
                    // messageSet({type: "danger", message: "An error occurred."});
                    twitchNameSet(null);
                });
            });
            window.Twitch.ext.onContext = ((ctx: TwitchContextDto) => {
                console.log("Twitch context", ctx);
                if(ctx.game !== "Fairytale Fables") disabledSet(true);
            });
        }
    }, [location, location.search]);

    if(!twitchName || disabled) return <></>;
    return <>
        <Board twitchName={twitchName}/>
    </>;
}